/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
var I = /* @__PURE__ */ ((E) => (E.DEFAULT = "DEFAULT", E.FULLSCREEN = "FULLSCREEN", E.MINIMIZED = "MINIMIZED", E))(I || {});
export {
  I as windowStage
};
